module.exports = __webpack_public_path__ + "static/img/newbanner-2x.23134e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newbanner-2x.png
// module id = RDqu
// module chunks = 0